import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { Predicate, PredicateOperator } from '@app/automations/model';

@Component({
  selector: 'dgx-predicate-list',
  templateUrl: './predicate-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PredicateListComponent {
  @Input() public predicates: Predicate[];
  @Input() public operators: PredicateOperator[];

  public trackById(index: number, operator: PredicateOperator) {
    return operator.id;
  }
}
